import React from 'react';
import {
  Box,
  Container,
  Typography,
  AppBar,
  Toolbar,
  Button,
  Stack,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <Box sx={{ backgroundColor: '#fafafa', minHeight: '100vh' }}>
      {/* ヘッダー */}
      <AppBar position="static" sx={{ backgroundColor: '#fff', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: 'space-between' }}>
            <Typography variant="h6" component="div" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
              マンション家計簿
            </Typography>
            <Stack direction="row" spacing={2}>
              <Button color="primary" onClick={handleBackToHome}>
                ホームに戻る
              </Button>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      {/* 利用規約内容 */}
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" color="primary" textAlign="center">
          利用規約
        </Typography>
        
        <Typography variant="body1" color="text.secondary" textAlign="center" sx={{ mb: 4 }}>
          最終更新日：2025年8月16日
        </Typography>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第1条（本規約の適用）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            本利用規約（以下「本規約」）は、マンション家計簿（以下「当サービス」）の利用に関する条件を定めるものです。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ユーザーは、当サービスを利用することにより、本規約に同意したものとみなされます。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第2条（定義）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            本規約において、以下の用語は以下の意味を有するものとします：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">「ユーザー」：当サービスを利用する個人または法人</Typography>
            <Typography component="li" variant="body1">「管理組合」：マンション管理組合法に基づく管理組合</Typography>
            <Typography component="li" variant="body1">「財務データ」：収支情報、会計データ等の財務に関する情報</Typography>
            <Typography component="li" variant="body1">「コンテンツ」：当サービス上の文字、画像、動画、その他の情報</Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第3条（利用登録）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスの利用を希望する者は、本規約に同意の上、当サービスの定める方法によって利用登録を申請し、当サービスがこれを承認することによって、利用登録が完了するものとします。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスは、利用登録の申請者が以下の事由に該当する場合、利用登録の申請を承認しないことがあります：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">利用登録の申請に際して虚偽の事項を届け出た場合</Typography>
            <Typography component="li" variant="body1">本規約に違反したことがある者からの申請である場合</Typography>
            <Typography component="li" variant="body1">その他、当サービスが利用登録を相当でないと判断した場合</Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第4条（アカウントの管理）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ユーザーは、自己の責任において、当サービスのアカウントを適切に管理するものとします。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ユーザーは、アカウントを第三者に利用させ、または貸与、譲渡、名義変更、売買その他の処分をしてはなりません。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            アカウントの管理不十分、使用上の過誤、第三者の使用等によって生じた損害の責任はユーザーが負うものとし、当サービスは一切の責任を負いません。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第5条（禁止事項）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ユーザーは、当サービスの利用にあたり、以下の行為をしてはなりません：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">法令または公序良俗に違反する行為</Typography>
            <Typography component="li" variant="body1">犯罪行為に関連する行為</Typography>
            <Typography component="li" variant="body1">当サービスの運営を妨害するおそれのある行為</Typography>
            <Typography component="li" variant="body1">他のユーザーに関する個人情報等を収集または蓄積する行為</Typography>
            <Typography component="li" variant="body1">他のユーザーに成りすます行為</Typography>
            <Typography component="li" variant="body1">当サービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</Typography>
            <Typography component="li" variant="body1">その他、当サービスが不適切と判断する行為</Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第6条（利用料金）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスの基本機能は無料でご利用いただけます。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            有料機能を提供する場合は、別途料金体系を定め、事前にユーザーに通知いたします。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            有料機能の利用料金は、当サービスの定める方法により支払うものとします。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第7条（知的財産権）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスに関する知的財産権は、当サービスまたは当サービスにその利用を許諾した権利者に帰属します。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ユーザーは、当サービスを利用することによって得られる情報を、当サービスが予め許諾する範囲を超えて利用してはなりません。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第8条（データの取り扱い）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ユーザーが当サービスに登録する財務データの所有権は、ユーザーに帰属します。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスは、ユーザーの財務データを、サービスの提供および品質向上を目的として利用することがあります。
また、当該財務データについては、ユーザー個人、管理組合、またはマンションを特定できない形式に加工したうえで、第三者への提供を含むサービスの運営・改善等に利用する場合があります。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ユーザーは、定期的にデータのバックアップを取ることを推奨します。システム障害等によるデータの消失について、当サービスは責任を負いません。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第9条（サービスの提供停止等）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスは、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします：
          </Typography>
          <Box component="ul" sx={{ pl: 3 }}>
            <Typography component="li" variant="body1">システムの保守点検や更新を行う場合</Typography>
            <Typography component="li" variant="body1">地震、落雷、火災、停電などの不可抗力により、サービスの提供が困難となった場合</Typography>
            <Typography component="li" variant="body1">その他、当サービスがサービスの提供が困難と判断した場合</Typography>
          </Box>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第10条（免責事項）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスは、本サービスに事実上または法律上の瑕疵がないことを明示的にも黙示的にも保証しておりません。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスは、本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について、当サービスは一切責任を負いません。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第11条（規約の変更）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            当サービスは、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            変更後の規約は、当サービス上に表示された時点より効力を生じるものとします。
          </Typography>
        </Paper>

        <Paper sx={{ p: 4, mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom fontWeight="bold" color="primary">
            第12条（準拠法・裁判管轄）
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            本規約の解釈にあたっては、日本法を準拠法とします。
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            本サービスに関して紛争が生じた場合には、東京地方裁判所を専属的合意管轄とします。
          </Typography>
        </Paper>

        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button variant="contained" size="large" onClick={handleBackToHome}>
            ホームに戻る
          </Button>
        </Box>
      </Container>
    </Box>
  );
};